import * as Customer from '@/services/rest-api/lib/customer/customer'
import * as MarketingUser from '@/services/rest-api/lib/customer/marketing-user'
import { TMS_MARKETING_USER_FILTER } from '@/helpers/tms-access'

const fields = [
  {
    name: 'shipped_customer_id',
    showKey: 'shipped_customer.id',
    label: 'Pelanggan Penerima',
    type: 'value-help-v2',
    placeholder: 'Pilih Nama Pelanggan',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Customer.get,
    validation: 'required',
    help: true,
    tableFields: [
      {
        label: 'Nama Pelanggan',
        key: 'name',
        isSortable: true,
        thStyle: 'width: 350px',
      },
      {
        label: 'Karyawan Pemasaran',
        key: 'marketing_user.name',
        isSortable: true,
      },
    ],
  },
  {
    name: 'billed_customer_id',
    showKey: 'billed_customer.id',
    label: 'Pelanggan Tertagih',
    placeholder: 'Pilih Nama Pelanggan',
    type: 'value-help-v2',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Customer.get,
    disabled: true,
  },
  {
    name: 'marketing_user_id',
    showKey: 'marketing_user.id',
    placeholder: 'Pilih Karyawan Pemasaran',
    type: 'select-resourceful-v2',
    label: 'Karyawan Pemasaran',
    optionsGetter: MarketingUser.get(TMS_MARKETING_USER_FILTER),
    optionLabelFn: ({ item }) => item.name,
  },
]

export default fields